const sensorsGPSDashboardActions = {
  // SET_LAST_GPS_PARAMS: 'SET_LAST_GPS_PARAMS',
  TOGGLE_SENS0R_SELECTED: 'TOGGLE_SENS0R_SELECTED',

  GET_LAST_DEVICES_GPS: 'GET_LAST_DEVICES_GPS',
  GET_LAST_DEVICES_GPS_SUCCESS: 'GET_LAST_DEVICES_GPS_SUCCESS',
  GET_LAST_DEVICES_GPS_ERROR: 'GET_LAST_DEVICES_GPS_ERROR',

  GET_SENSORS_GPS_HISTORY: 'GET_SENSORS_GPS_HISTORY',
  GET_SENSORS_GPS_HISTORY_SUCCESS: 'GET_SENSORS_GPS_HISTORY_SUCCESS',
  GET_SENSORS_GPS_HISTORY_ERROR: 'GET_SENSORS_GPS_HISTORY_ERROR',
};

// const setLastGPSParams = (payload) => ({
//   type: sensorsGPSDashboardActions.SET_LAST_GPS_PARAMS,
//   payload,
// });

const toggleSensorSelected = (payload) => ({
  type: sensorsGPSDashboardActions.TOGGLE_SENS0R_SELECTED,
  payload,
});

const getLastDevicesGPS = (data) => ({
  type: sensorsGPSDashboardActions.GET_LAST_DEVICES_GPS,
  payload: data,
});
const getSensorsPositionSuccess = (data) => ({
  type: sensorsGPSDashboardActions.GET_LAST_DEVICES_GPS_SUCCESS,
  payload: data,
});
const getSensorsPositionError = () => ({
  type: sensorsGPSDashboardActions.GET_LAST_DEVICES_GPS_ERROR,
});

const getSensorsGPSHistory = (data) => ({
  type: sensorsGPSDashboardActions.GET_SENSORS_GPS_HISTORY,
  payload: data,
});
const getSensorsGPSHistorySuccess = (data) => ({
  type: sensorsGPSDashboardActions.GET_SENSORS_GPS_HISTORY_SUCCESS,
  payload: data,
});
const getSensorsGPSHistoryError = () => ({
  type: sensorsGPSDashboardActions.GET_SENSORS_GPS_HISTORY_ERROR,
});

export {
  sensorsGPSDashboardActions,
  toggleSensorSelected,
  getLastDevicesGPS,
  getSensorsPositionSuccess,
  getSensorsPositionError,
  getSensorsGPSHistory,
  getSensorsGPSHistorySuccess,
  getSensorsGPSHistoryError,
};
